<template>
  <li class="tree">
    <div
      class="parent"
      :class="{
        bold: isFolder,
        company: item.nombre === company.razonSocial,
        selected: selected && (item.id === selected.id) && item.id
      }"
      data-cy="company"
    >
      <span v-if="isFolder" @click="toggle">
         <feather-icon
           v-if="!isOpen"
           icon="ChevronRightIcon"
           class="cursor-pointer current-step ml-2"
         />
        <feather-icon
          v-if="isOpen"
          icon="ChevronDownIcon"
          class="cursor-pointer current-step ml-2"
        />
      </span>
      <span>
        <feather-icon
          size="14"
          v-if="isInternOffice"
          icon="AwardIcon"
          v-tooltip="'Es Oficina Interna'"
          class="cursor-default current-step ml-2 is-intern"
        />
        <feather-icon
          size="14"
          v-if="isExternOffice"
          icon="AwardIcon"
          v-tooltip="'Es Oficina Externa'"
          class="cursor-default current-step ml-2 is-extern"
        />
        <feather-icon
          size="14"
          v-if="checkGroup"
          icon="UsersIcon"
          v-tooltip="'Es Grupo'"
          class="cursor-default current-step ml-2"
        />
      </span>
      <span
        class="pb-2 pl-2"
        @click="getChildren"
      >
        {{ item.nombre }}
      </span>
      <CheckPermission permission="ED074">
        <div
          v-if="item.type !== 'subcategory' && item.type !== 'category'"
          class="dropdown">
          <b-dropdown
              data-cy="options"
              variant="link"
              toggle-class="actions ml-2"
              no-caret
              left
          >
            <template #button-content>
              <div class="p-0">
                <feather-icon
                    size="18"
                    icon="PlusCircleIcon"
                    class="align-middle text-body p-0"
                />
              </div>
            </template>
            <b-dropdown-item
                v-if="item.nombre !== company.razonSocial && !isOffice"
                @click="$emit('edit-group', item)"
                data-cy="edit-group"
            >
              Editar grupo
            </b-dropdown-item>
            <b-dropdown-item
                v-if="isOffice"
                @click="$emit('edit-group', item)"
                data-cy="edit-group"
            >
              Editar oficina
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!isOffice && item.nombre !== company.razonSocial"
              @click="$emit('remove-group', item)"
              data-cy="remove-group"
            >
              <span>
                Remover Grupo
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="isOffice && item.nombre !== company.razonSocial"
              @click="$emit('remove-group', item)"
              data-cy="remove-group"
            >
              <span>
                Remover Oficina
              </span>
            </b-dropdown-item>
            <b-dropdown-item
                v-if="item.nombre !== company.razonSocial && !isOffice"
                @click="$emit('add-sub-group', item)"
                data-cy="add-sub-group"
            >
              Agregar sub-grupo
            </b-dropdown-item>
            <b-dropdown-item
                v-if="item.nombre !== company.razonSocial && !isOffice"
                @click="$emit('users-group', item)"
                data-cy="users-group"
            >
              Usuarios del grupo
            </b-dropdown-item>
            <b-dropdown-item
                v-if="item.nombre !== company.razonSocial && isOffice"
                @click="$emit('users-group', item)"
                data-cy="users-group"
            >
              Usuarios de la oficina
            </b-dropdown-item>
            <CheckPermission permission="ED051">
              <b-dropdown-item
                  v-if="(item.nombre !== company.razonSocial) && item.esOficina === 'Y'"
                  @click="$emit('config-numeration', item)"
                  data-cy="config-numeration"
              >
                Numeración
              </b-dropdown-item>
            </CheckPermission>
            <b-dropdown-item
                v-if="item.nombre === company.razonSocial && groupMood"
                @click="$emit('add-group', item)"
                data-cy="add-group"
            >
              Agregar grupo
            </b-dropdown-item>
            <b-dropdown-item
              v-if="item.nombre === company.razonSocial && !groupMood"
              @click="$emit('add-office', item)"
              data-cy="add-office"
            >
              Agregar oficina
            </b-dropdown-item>
            <b-dropdown-item
                v-if="groupMood"
                @click="$emit('add-user', item)"
                data-cy="add-user"
            >
              Agregar usuario
            </b-dropdown-item>
            <b-dropdown-item
              v-if="groupMood"
              @click="$emit('add-massive-users', item)"
              data-cy="add-massive-users"
            >
              Agregar usuarios masivo
            </b-dropdown-item>
            <b-dropdown-item
              v-if="item.nombre === company.razonSocial"
              @click="$emit('remove-user', item)"
              data-cy="remove-user"
            >
              Remover usuario
            </b-dropdown-item>
            <b-dropdown-item
              @click="$emit('leader-group', item)"
              data-cy="leader-group"
            >
              <span v-if="!isOffice">
                Líder de Grupo
              </span>
              <span v-if="isOffice">
                Líder de Oficina
              </span>
            </b-dropdown-item>
            <CheckPermission permission="ED115">
              <b-dropdown-item
                v-if="isOffice"
                @click="$emit('config-entity-doc-digital', item)"
                data-cy="config-entity-docdigital"
              >
                Configurar entidad Doc Digital
              </b-dropdown-item>
            </CheckPermission>
          </b-dropdown>
        </div>
      </CheckPermission>
    </div>
    <ul v-if="isFolder && isOpen">
      <tree-item
        class="item"
        v-for="(child, index) in item.children"
        :class="getClass(item)"
        :key="index"
        :item="child"
        :selected="selected"
        :groupMood="groupMood"
        @get-children="$emit('get-children', $event)"
        @edit-group="$emit('edit-group', $event)"
        @add-group="$emit('add-group', $event)"
        @add-office="$emit('add-office', $event)"
        @users-group="$emit('users-group', $event)"
        @leader-group="$emit('leader-group', $event)"
        @add-sub-group="$emit('add-sub-group', $event)"
        @add-user="$emit('add-user', $event)"
        @add-massive-users="$emit('add-massive-users', $event)"
        @remove-user="$emit('remove-user', $event)"
        @remove-group="$emit('remove-group', $event)"
        @config-numeration="$emit('config-numeration', $event)"
        @config-entity-doc-digital="$emit('config-entity-doc-digital', $event)"
      />
    </ul>
  </li>
</template>
<script>
import { mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  name: 'tree-item',
  components: {
    CheckPermission
  },
  props: {
    item: Object,
    selected: Object,
    groupMood: Boolean,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    // Permite dejar abierto el árbol de la empresa
    if (this.item.nombre.length && this.company.razonSocial.length) {
      this.isOpen = this.item.nombre === this.company.razonSocial;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    isFolder() {
      return this.item.isRoot || (this.item.children && this.item.children.length > 0);
    },
    checkGroup() {
      return (this.item.esDivision === 'N' && this.item.esOficina === 'N');
    },
    isDivision() {
      return (this.item.esDivision === 'Y');
    },
    isInternOffice() {
      return this.item.esOficina === 'Y' && this.item.tipo === 'int';
    },
    isExternOffice() {
      return this.item.esOficina === 'Y' && this.item.tipo === 'ext';
    },
    isOffice() {
      return this.item.esOficina === 'Y';
    }
  },
  methods: {
    // eslint-disable-next-line
    getClass(item) {
      if (item.type === 'category' || item.type === 'subcategory') {
        return 'cursor-default';
      }
    },
    toggle() {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    getChildren() {
      this.$emit('get-children', this.item);
    }
  },
};
</script>
<style lang="scss">
.item {
  cursor: pointer;
  list-style: none;
}
.bold {
  font-weight: bold;
}
.actions.btn.btn-link {
  padding: 0 0 4px 2px !important;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
.parent {
  display: flex;
  align-content: center;
}
.dropdown-menu {
  z-index: 1000000;
}
.company {
  color: #6f1788;
  background: #ae48a31f;
  border-radius: 5px;
}

.selected {
  color: #6f1788;
  background-color: #f1f0f0;
}

.is-intern {
  color: #91bd3c;
}

.is-extern {
  color: #276a9e;
}
</style>
